module.exports = __webpack_public_path__ + "static/media/DEFENSE_COVID-19_Logo_RGB.77fb805b.svg";